import type { App, Plugin } from 'vue'

import { FocusTrapPlugin } from './focustrap'
import { vLazyImgInstall } from './lazy-img'

const directives = [vLazyImgInstall, FocusTrapPlugin] satisfies Plugin[]

const plugin = {
	install(app: App) {
		for (const directive of directives) {
			app.use(directive)
		}
	},
} satisfies Plugin

export default defineNuxtPlugin(nuxtApp => {
	nuxtApp.vueApp.use(plugin)
})
